const indexOf = (list, item) => list.indexOf(item);

/**
 * Adds item to list if list doesn't contain the item, otherwise returns the same list
 *
 * @type {<T>(list?: T[], item: T) => T[]}
 */
export const include = (list = [], item) => (list.includes(item) ? list : [...list, item]);

/**
 * Removes item from list if item is in the list, otherwise returns the same list
 *
 * @type {<T>(list?: T[], item: T) => T[]}
 */
export const exclude = (list = [], item) => {
	const index = list.length > 0 ? indexOf(list, item) : -1;
	if (index < 0) return list;
	return [
		...list.slice(0, index), // copy before removing item
		...list.slice(index + 1), // copy after removing item
	];
};
